const ContentEmptyState = ({ onCreate, learnerPlural = "students" }) => (
    <section className="content-empty-state">
        <p className="eyebrow">Reading Library</p>
        <h2>Your reading library is empty 📚</h2>
        <p>{`Create your first reading content and assign it to your ${learnerPlural}.`}</p>
        <button type="button" className="lms-primary-action" onClick={onCreate}>
            Create first content
        </button>
    </section>
);

export default ContentEmptyState;
